import { useEffect } from "react";
import i18n, { type Language } from "@/src/common/locales/i18n";

interface HydrationLanguageSyncProps {
	language: Language;
}

export function HydrationLanguageSync({ language }: HydrationLanguageSyncProps) {
	useEffect(() => {
		if (i18n.resolvedLanguage !== language) {
			void i18n.changeLanguage(language);
		}
	}, [language]);

	return null;
}
